export default {
  metadata: {
    version: '1.0.0',
    id: 'divider-1.0.0',
    name: 'JDSDivider',
    description:
      'Dividers are used to group and divide contents within a page.',
    usage:
      'Dividers are used inorder to establish clear grouping of content or emphasize the in-between boundaries of a list of content.'
  },
  hierarchy: {
    container: ['start-container', 'jds-text', 'end-container']
  },
  base: {
    container: {
      hidden: false,
      'background-color': '{d_0}',
      'flex-direction': '{d_1}',
      'justify-content': '{d_2}',
      'align-items': '{d_3}',
      gap: '{d_4}',
      flex: 1,
      'padding-left': '{d_5}',
      'padding-right': '{d_6}',
      'padding-top': '{d_7}',
      'padding-bottom': '{d_8}'
    },
    'start-container': {
      hidden: false,
      'min-height': '{d_9}',
      'min-width': '{d_10}',
      'flex-direction': '{d_11}',
      flex: 1,
      'background-color': '{d_12}',
      'border-radius': '{d_13}',
      show: true
    },
    'end-container': {
      hidden: true,
      'min-height': '{d_14}',
      'min-width': '{d_15}',
      'flex-direction': '{d_16}',
      flex: 1,
      'background-color': '{d_17}',
      'border-radius': '{d_18}',
      show: true
    },
    'jds-text': {
      'font-family': '{text_152}',
      color: '{text_21}',
      'font-size': '{text_151}',
      'line-height': '{text_153}',
      'letter-spacing': '{text_154}',
      'font-weight': '{text_155}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    }
  },
  variant: {
    variant: {
      stepper: {
        'start-container': {
          'background-color': '{d_19}'
        },
        'end-container': {
          'background-color': '{d_20}'
        }
      }
    },
    orientation: {
      horizontal: {
        container: {
          width: '{d_21}'
        },
        'start-container': {
          height: 1
        },
        'end-container': {
          height: 1
        }
      },
      vertical: {
        container: {
          height: '{d_22}',
          'flex-direction': '{d_23}'
        },
        'start-container': {
          width: 1,
          'flex-direction': '{d_24}',
          flex: 1
        },
        'end-container': {
          width: 1,
          'flex-direction': '{d_25}',
          flex: 1
        }
      }
    },
    pad: {
      none: {
        container: {
          'padding-top': 0,
          'padding-bottom': 0,
          'padding-right': 0,
          'padding-left': 0
        }
      }
    },
    _withLabel: {
      true: {
        'end-container': {
          hidden: false
        },
        'jds-text': {
          hidden: false
        }
      }
    }
  },
  combination: [
    {
      base: {
        all: {
          container: {
            'padding-left': '{d_26}',
            'padding-right': '{d_27}',
            'padding-top': '{d_28}',
            'padding-bottom': '{d_29}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_30}',
            'padding-right': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_31}',
            'padding-left': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-right': 0,
            'padding-left': 0,
            'padding-top': '{d_32}'
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-right': 0,
            'padding-left': 0,
            'padding-bottom': '{d_33}'
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_34}',
            'padding-right': 0,
            'padding-left': 0,
            'padding-bottom': '{d_35}'
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': '{d_36}',
            'padding-right': '{d_37}'
          }
        }
      },
      medium: {
        all: {
          container: {
            'padding-left': '{d_38}',
            'padding-right': '{d_39}',
            'padding-top': '{d_40}',
            'padding-bottom': '{d_41}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_42}',
            'padding-right': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_43}',
            'padding-left': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-right': 0,
            'padding-left': 0,
            'padding-bottom': 0,
            'padding-top': '{d_44}'
          }
        },
        bottom: {
          container: {
            'padding-right': 0,
            'padding-left': 0,
            'padding-top': 0,
            'padding-bottom': '{d_45}'
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_46}',
            'padding-bottom': '{d_47}',
            'padding-right': 0,
            'padding-left': 0
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': '{d_48}',
            'padding-right': '{d_49}'
          }
        }
      },
      'xtra-small': {
        all: {
          container: {
            'padding-left': '{d_50}',
            'padding-right': '{d_51}',
            'padding-top': '{d_52}',
            'padding-bottom': '{d_53}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_54}',
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-right': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_55}',
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-top': '{d_56}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-bottom': '{d_57}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_58}',
            'padding-bottom': '{d_59}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': '{d_60}',
            'padding-right': '{d_61}'
          }
        }
      },
      'xtra-xtra-small': {
        all: {
          container: {
            'padding-left': '{d_62}',
            'padding-right': '{d_63}',
            'padding-top': '{d_64}',
            'padding-bottom': '{d_65}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_66}',
            'padding-right': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_67}',
            'padding-left': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-top': '{d_68}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-bottom': '{d_69}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_70}',
            'padding-bottom': '{d_71}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-right': 0,
            'padding-left': '{d_72}',
            'padding-bottom': '{d_73}'
          }
        }
      },
      'xtra-xtra-large': {
        all: {
          container: {
            'padding-left': '{d_74}',
            'padding-right': '{d_75}',
            'padding-top': '{d_76}',
            'padding-bottom': '{d_77}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_78}',
            'padding-right': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_79}',
            'padding-top': 0,
            'padding-left': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-top': '{d_80}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-bottom': '{d_81}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_82}',
            'padding-bottom': '{d_83}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': '{d_84}',
            'padding-right': '{d_85}'
          }
        }
      },
      'xtra-large': {
        all: {
          container: {
            'padding-left': '{d_86}',
            'padding-right': '{d_87}',
            'padding-top': '{d_88}',
            'padding-bottom': '{d_89}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_90}',
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_91}',
            'padding-top': 0,
            'padding-left': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-left': 0,
            'padding-right': 0,
            'padding-top': '{d_92}'
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-left': 0,
            'padding-right': 0,
            'padding-bottom': '{d_93}'
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_94}',
            'padding-left': 0,
            'padding-right': 0,
            'padding-bottom': '{d_95}'
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': '{d_96}',
            'padding-right': '{d_97}'
          }
        }
      },
      large: {
        all: {
          container: {
            'padding-left': '{d_98}',
            'padding-right': '{d_99}',
            'padding-top': '{d_100}',
            'padding-bottom': '{d_101}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_102}',
            'padding-right': '0',
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_103}',
            'padding-left': '0',
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-left': 0,
            'padding-right': 0,
            'padding-top': '{d_104}'
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-left': 0,
            'padding-right': 0,
            'padding-bottom': '{d_105}'
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_106}',
            'padding-left': 0,
            'padding-right': 0,
            'padding-bottom': '{d_107}'
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': '{d_108}',
            'padding-right': '{d_109}'
          }
        }
      },
      huge: {
        all: {
          container: {
            'padding-left': '{d_110}',
            'padding-right': '{d_111}',
            'padding-top': '{d_112}',
            'padding-bottom': '{d_113}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_114}',
            'padding-right': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_115}',
            'padding-top': 0,
            'padding-left': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-top': '{d_116}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-bottom': '{d_117}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_118}',
            'padding-bottom': '{d_119}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': '{d_120}',
            'padding-right': '{d_121}'
          }
        }
      },
      massive: {
        all: {
          container: {
            'padding-left': '{d_122}',
            'padding-right': '{d_123}',
            'padding-top': '{d_124}',
            'padding-bottom': '{d_125}'
          }
        },
        left: {
          container: {
            'padding-left': '{d_126}',
            'padding-right': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-right': '{d_127}',
            'padding-left': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-top': '{d_128}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-bottom': '{d_129}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        vertical: {
          container: {
            'padding-top': '{d_130}',
            'padding-bottom': '{d_131}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0,
            'padding-left': '{d_132}',
            'padding-right': '{d_133}'
          }
        }
      },
      small: {
        left: {
          container: {
            'padding-right': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        right: {
          container: {
            'padding-left': 0,
            'padding-top': 0,
            'padding-bottom': 0
          }
        },
        top: {
          container: {
            'padding-bottom': 0,
            'padding-left': 0,
            'padding-right': 0
          }
        },
        bottom: {
          container: {
            'padding-top': 0,
            'padding-left': 0,
            'padding-right': 0
          }
        },
        vertical: {
          container: {
            'padding-left': 0,
            'padding-right': 0
          }
        },
        horizontal: {
          container: {
            'padding-top': 0,
            'padding-bottom': 0
          }
        }
      }
    }
  ],
  combination_config: [['pad', 'padPosition']],
  api: {
    data: {
      'jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    config: {
      orientation: {
        values: ['horizontal', 'vertical'],
        doc_description:
          'Determines the view styles i.e. horizontal or vertical.'
      },
      variant: {
        values: ['default', 'stepper']
      },
      _withLabel: {
        values: [false, true]
      },
      padPosition: {
        values: [
          'all',
          'vertical',
          'horizontal',
          'bottom',
          'top',
          'left',
          'right'
        ],
        doc_description:
          'Sets the position of padding defined as part of `padding` property. If `padding` property present, this default to `all`.'
      },
      pad: {
        values: [
          'small',
          'base',
          'medium',
          'xtra-small',
          'large',
          'xtra-large',
          'xtra-xtra-large',
          'xtra-xtra-small',
          'huge',
          'massive',
          'none'
        ]
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'separator'
          },
          'aria-label': {
            name: '_ariaLabel',
            prop: 'label',
            function: true
          },
          'aria-orientation': {
            name: '_ariaOrientation',
            prop: 'orientation'
          },
          'aria-hidden': {
            name: 'ariaHidden'
          }
        }
      }
    }
  }
};
